import asciiToArray from "./component-library255.mjs";
import hasUnicode from "./component-library239.mjs";
import unicodeToArray from "./component-library256.mjs";
function stringToArray(string) {
  return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
}
export {
  stringToArray as default
};
